export enum RingIds {
    ExerciseRing = 'ExerciseRing',
    ZoomRing = 'ZoomRing',
    ViewRing = 'ViewRing',
    NavigationRing = 'NavigationRing',
    EditRing = 'EditRing',
}
